import React, { useRef, useEffect } from 'react';

import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  // BooleanField,
  DateField,
  useRefresh,
  Pagination,
  // NumberField,
  // ChipField,
  // Filter,
  // TextInput,
  // ReferenceField,
  // ShowGuesser,
} from 'react-admin';
import { Toolbar, Button, Link } from '@material-ui/core';
import { LaunchIcon } from '../../design';
import { useStyles } from './progress.styles';

const CaseLevelActions = ({ integration_id }) => {
  const classes = useStyles();
  return (
    <Toolbar
      className={classes.listActionWrapper}
      disableGutters
      // style={{ minHeight: '100%' }}
    >
      <div className={classes.listActionWrapper} style={{ padding: 24 }}>
        <span />
        {!!integration_id && (
          <Button
            color='primary'
            component={Link}
            underline='none'
            href={`https://usnpint.pointclickcare.com/clinical/ordersChart.xhtml?ESOLclientid=${integration_id}`}
            target='_blank'
            rel='noopener noreferrer'
            style={{ textTransform: 'none' }}
            startIcon={<LaunchIcon />}
          >
            View Medication in PointClickCare
          </Button>
        )}
      </div>
    </Toolbar>
  );
};

export function MedicationList({ staticContext, integration_id, ..._props }) {
  const { formBasePath, caseId, ...props } = getResourceProps(_props);
  const classes = useStyles();
  const refresh = useRefresh();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseId]);

  return (
    <List
      empty={false}
      {...props}
      exporter={false}
      bulkActionButtons={false}
      className={classes.list}
      actions={<CaseLevelActions integration_id={integration_id} />}
      pagination={
        <Pagination
          rowsPerPageOptions={[]}
          rowsPerPage={1000}
          style={{
            display: 'flex',
          }}
        />
      }
      sort={{ field: 'startDate', order: 'ASC' }}
    >
      <Datagrid>
        <DateField sortable={true} label='Date' source='startDate' />
        <TextField sortable={true} label='Description' source='description' />
        <TextField sortable={true} label='Generic' source='generic' />
        <TextField sortable={false} label='Directions' source='directions' />
        <FunctionField
          sortable={true}
          label='Route Of Administration'
          source='administrationDisplay'
          render={record => {
            const { administrationDisplay } = record;
            return (
              Array.isArray(administrationDisplay) &&
              administrationDisplay.join(', ')
            );
          }}
        />
        <TextField sortable={true} label='Status' source='status' />
      </Datagrid>
    </List>
  );
}

export const medicationResource = {
  name: 'clinical/medications',
  list: MedicationList,
};

function getResourceProps(props) {
  const {
    location: { pathname } = {},
    match: { params: { id: caseId } = {} } = {},
  } = props;
  const basePath = pathname;
  const resource = props.resource
    ? { resource: props.resource }
    : {
        resource: 'clinical/medications',
        hasList: true,
        hasEdit: !!medicationResource.edit,
        hasShow: !!medicationResource.show,
        hasCreate: !!medicationResource.create,
      };
  const updatedProps = {
    ...props,
    basePath,
    caseId,
    ...resource,
  };
  return updatedProps;
}
